export interface SavedCondition {
  name?: string;
  displayName?: string;
  condition?: string;
  values?: string;
  weightUnit?: string;
  subsetGroupId?: number | null;
  optionalValue?: unknown;
}

export interface PriceTier {
  minOrderPriceRange?: number;
  maxOrderPriceRange?: number | null;
  rate?: number;
  hasDiscount?: boolean;
  discountType?: string;
  discountAmount?: number | null;
}

export interface ZoneOption {
  label: string;
  value: boolean;
}

export const LOCATIONS_CONDITION = {
  condition: 'are',
  name: 'locations',
  displayName: 'Locations',
  values: '', // polygon city/address lists are not saved
  locationValues: [],
};

export const AREA_LIST_FIELDS = ['excludedCities', 'listedStates', 'listedCities', 'excludedStates'] as const;

export type AreaListField = (typeof AREA_LIST_FIELDS)[number];

export interface ScheduleDay {
  day?: string;
  enable?: boolean;
  fromTime?: string;
  toTime?: string;
}
